<script>
  import sysData from "../../Stores/systemStore.js";
  import schemaData from "../../Stores/wpn2SchemaStore.js";

  export let item;
  export let showTitle = false;
  let iconUrl;

  $: iconUrl = iconUrlForItem(item);

  function iconUrlForItem(item) {
    if (item != undefined && item.icon_name != undefined) {
      switch (item.status) {
        case "Medium":
        case "Monitor":
        case "Yellow":
          return "data:image/png;base64," + $sysData.icons["iconLightYellow"];
        case "High":
        case "Alert":
        case "Red":
          return "data:image/png;base64," + $sysData.icons["iconLightRed"];
        case "Low":
        case "Normal":
        case "Green":
          return "data:image/png;base64," + $sysData.icons["iconLightGreen"];
        default:
          return "data:image/png;base64," + $sysData.icons["iconLightGray"];
      }
    }
  }
</script>

<div id="name-col">
  <div>
    {#if showTitle}
      {$schemaData["keysList"].find((x) => x.key === "status").title + ": "}
    {/if}
    <img id="status-icon-image" src={iconUrl} alt="Item logo" />
  </div>
</div>

<style>
  #status-icon-image {
    width: 12px;
    height: 12px;
    margin: -1px 2px;
    vertical-align: center;
  }
</style>
